import { render, staticRenderFns } from "./LoginFormTwoFactorStep.vue?vue&type=template&id=37462960"
import script from "./LoginFormTwoFactorStep.vue?vue&type=script&lang=js"
export * from "./LoginFormTwoFactorStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports